import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { PagedList } from "../model/domain/PagedList";

@Injectable({
  providedIn: "root",
})
export class TabelaBoletaService {
  constructor(private http: HttpClient) {}

  GetFiles(
    page: number = null,
    pageSize: number = null,
    ticketType: number = null,
    startDate: Date = null,
    endDate: Date = null
  ) {
    const params: any = {};

    if (startDate) {
      params.startDate = startDate.toJSON();
    }

    if (endDate) {
      params.endDate = endDate.toJSON();
    }

    if (ticketType) {
      params.ticketType = ticketType.toString();
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }
    return this.http.get<PagedList<any>>(
      `${environment.apiUrls.tickets}/ticket-upload/ticket-history`,
      {
        params,
      }
    );
  }
}
